export const copy = {
  en: {
    nav: {
      links: [
        { id: "house", label: "The House" },
        { id: "land", label: "The Land" },
        { id: "wellness", label: "Wellness" },
        { id: "weddings", label: "Weddings" },
        { id: "retreats", label: "Retreats" },
        { id: "gallery", label: "Gallery" },
      ],
      enquire: "Enquire",
    },
    hero: {
      eyebrow: "Newborough · Anglesey · Wales",
      lines: ["Where coastal wildness", "meets manor house", "elegance."],
      bookRetreat: "Book a Retreat",
      bookWedding: "Book a Wedding",
      enquireStay: "Enquire to Stay",
      stats: ["Sleeps 15 — 23", "8 Ensuite Bedrooms", "8 Private Acres", "Basement Wellness Suite"],
    },
    marquee: [
      "Newborough Beach",
      "Basement Wellness",
      "Llanddwyn Island",
      "8 Ensuite Bedrooms",
      "8 Private Acres",
      "Bespoke Weddings",
      "Mindful Retreats",
    ],
    chapters: [
      {
        id: "house",
        number: "01",
        title: "The House",
        heading: "A manor, lovingly reimagined",
        body: "Bron Menai is a characterful country manor house, lovingly restored for meaningful gatherings. Eight elegant ensuite bedrooms sleep fifteen in the main house, rising to twenty-three with the neighbouring cottages — generous living spaces, layered textures and quiet luxury throughout.",
        facts: ["8 ensuite bedrooms", "Sleeps 15, up to 23", "Lovingly restored"],
        cta: null,
        ctaType: null,
      },
      {
        id: "land",
        number: "02",
        title: "The Land",
        heading: "Eight acres between forest and sea",
        body: "Set within eight private acres of grounds on the edge of Newborough, the manor sits minutes from Newborough Beach, the pine forest and the tidal island of Llanddwyn. Marram grass, wide skies and the mountains of Eryri on the horizon.",
        facts: ["8 private acres", "4 miles to Newborough Beach", "Views toward Eryri"],
        cta: null,
        ctaType: null,
      },
      {
        id: "wellness",
        number: "03",
        title: "The Wellness Suite",
        heading: "A sanctuary below the house",
        body: "Beneath the manor, a basement wellness suite built for deep restoration — a cedar sauna, cold plunge, hot tub and a quiet meditation space. Days here move between heat, cold, breath and stillness.",
        facts: ["Cedar sauna", "Cold plunge", "Hot tub & meditation space"],
        cta: null,
        ctaType: null,
      },
      {
        id: "weddings",
        number: "04",
        title: "Weddings",
        heading: "Your day, your house, your shoreline",
        body: "Take over Bron Menai entirely for an intimate coastal wedding. Exchange vows between forest and sea, dine beneath the manor's old beams and dance late into a Welsh summer night — with bedrooms for your favourite people, steps away.",
        facts: ["Exclusive multi-day hire", "House & grounds takeover", "Sleeps your wedding party"],
        cta: "Book a Wedding",
        ctaType: "wedding",
      },
      {
        id: "retreats",
        number: "05",
        title: "Retreats",
        heading: "Built for coming back to yourself",
        body: "Wellness, yoga, fitness, nature and watersports retreats find a natural home here. Purposeful spaces for movement and breathwork, a wellness suite for recovery, and eight acres of wild calm to hold it all.",
        facts: ["Yoga & movement spaces", "Nature & watersports", "Sensory healing in the wild"],
        cta: "Book a Retreat",
        ctaType: "retreat",
      },
    ],
    gallery: {
      overline: "The Gallery",
      headingPre: "Inside & out,",
      headingAccent: "every corner considered",
      note: "Real photography of the manor, the wellness suite and the eight acres",
      captions: ["The Manor", "The Sitting Room", "The Kitchen", "The Gardens", "Wellness Suite", "Gathering Spaces", "Details", "The Grounds"],
    },
    location: {
      overline: "The Setting",
      headingA: "Between the forest,",
      headingB: "the dunes and the sea.",
      body: "Bron Menai sits on Anglesey's southern edge in an Area of Outstanding Natural Beauty — marram grass dunes, tidal islands and the mountains of Eryri across the strait.",
      places: [
        { name: "Newborough Beach", time: "5 min drive" },
        { name: "Newborough Pine Forest", time: "2 min drive" },
        { name: "Llanddwyn Island", time: "10 min drive" },
        { name: "Eryri / Snowdonia", time: "25 min drive" },
      ],
      coordsLabel: "Newborough · Isle of Anglesey · Wales",
    },
    footer: {
      line1: "Find your wild",
      line2: "at Bron Menai",
      locationLine: "Newborough · Isle of Anglesey · Wales",
      copyright: "Bron Menai",
    },
    modal: {
      overline: "Enquire",
      title: "Begin your stay at Bron Menai",
      types: { stay: "A Stay", wedding: "A Wedding", retreat: "A Retreat" },
      fullName: "Full name *",
      email: "Email *",
      phone: "Phone",
      date: "Preferred date",
      partySize: "Party size *",
      message: "Your enquiry *",
      phName: "Your name",
      phEmail: "you@example.com",
      phPhone: "Optional",
      phMessage: "Tell us about your plans — dates, occasions, anything that matters.",
      submit: "Send Enquiry",
      sending: "Sending…",
      footnote: "Goes straight to tom@property-owl.com",
      successTitle: "Thank you.",
      successBody: "Your enquiry is on its way to the Bron Menai team at tom@property-owl.com. We'll be in touch shortly.",
      successBack: "Back to the house",
    },
    toast: {
      success: "Enquiry sent — we've emailed the Bron Menai team.",
      error: "Something went wrong sending your enquiry. Please email tom@property-owl.com directly.",
    },
  },
  cy: {
    nav: {
      links: [
        { id: "house", label: "Y Tŷ" },
        { id: "land", label: "Y Tir" },
        { id: "wellness", label: "Lles" },
        { id: "weddings", label: "Priodasau" },
        { id: "retreats", label: "Enciliadau" },
        { id: "gallery", label: "Oriel" },
      ],
      enquire: "Holwch",
    },
    hero: {
      eyebrow: "Niwbwrch · Ynys Môn · Cymru",
      lines: ["Lle mae gwylltineb yr arfordir", "yn cwrdd ag urddas", "y plasty."],
      bookRetreat: "Archebwch Encil",
      bookWedding: "Archebwch Briodas",
      enquireStay: "Holwch am Aros",
      stats: ["Yn cysgu 15 — 23", "8 Ystafell Wely en suite", "8 Acr Preifat", "Ystafell Lles Islawr"],
    },
    marquee: [
      "Traeth Niwbwrch",
      "Lles Islawr",
      "Ynys Llanddwyn",
      "8 Ystafell Wely en suite",
      "8 Acr Preifat",
      "Priodasau Unigryw",
      "Enciliadau Myfyriol",
    ],
    chapters: [
      {
        id: "house",
        number: "01",
        title: "Y Tŷ",
        heading: "Plasty, wedi'i ailgreu â serch",
        body: "Plasty gwledig cymeriadol yw Bron Menai, wedi'i adnewyddu'n llwyr ar gyfer cynulliadau ystyrlon. Mae wyth ystafell wely en suite yn cysgu pymtheg yn y prif dŷ, gan godi i dri ar hugain gyda'r bwthynnod cyfagos — lleoedd byw hael, gweadau haenog a moethusrwydd tawel drwy'r cyfan.",
        facts: ["8 ystafell wely en suite", "Yn cysgu 15, hyd at 23", "Adnewyddwyd â serch"],
        cta: null,
        ctaType: null,
      },
      {
        id: "land",
        number: "02",
        title: "Y Tir",
        heading: "Wyth acer rhwng coedwig a môr",
        body: "Wedi'i osod o fewn wyth acer preifat ar gyrion Niwbwrch, mae'r plasty funudau o Draeth Niwbwrch, y goedwig binwydd ac ynys llanw Llanddwyn. Gwellt y twyni, nenfbcau eang a mynyddoedd Eryri ar y gorwel.",
        facts: ["8 acer preifat", "4 milltir i Draeth Niwbwrch", "Golygfeydd tuag at Eryri"],
        cta: null,
        ctaType: null,
      },
      {
        id: "wellness",
        number: "03",
        title: "Yr Ystafell Lles",
        heading: "Noddfa o dan y tŷ",
        body: "O dan y plasty, ystafell lles islawr a adeiladwyd ar gyfer adferiad dwfn — sawna sedr, pwll trochi oer, twb poeth a man myfyrio tawel. Mae dyddiau yma'n symud rhwng gwres, oerfel, anadl a thawelwch.",
        facts: ["Sawna sedr", "Pwll trochi oer", "Twb poeth a man myfyrio"],
        cta: null,
        ctaType: null,
      },
      {
        id: "weddings",
        number: "04",
        title: "Priodasau",
        heading: "Eich diwrnod, eich tŷ, eich glannau",
        body: "Cymerwch Bron Menai yn gyfangwbl ar gyfer priodas arfordirol agos-atoch. Dywedwch eich addewidion rhwng coedwig a môr, bwytewch o dan hen drawstiau'r plasty a dawnsiwch yn hwyr i noson haf Gymreig — gydag ystafelloedd gwely i'ch pobl hoff, ychydig gamau i ffwrdd.",
        facts: ["Llogi unigryw am nifer o ddyddiau", "Meddiant ar y tŷ a'r tir", "Yn cysgu eich gwesteion priodas"],
        cta: "Archebwch Briodas",
        ctaType: "wedding",
      },
      {
        id: "retreats",
        number: "05",
        title: "Enciliadau",
        heading: "Adeiladwyd i ddod yn ôl atoch eich hun",
        body: "Mae enciliadau lles, ioga, ffitrwydd, natur a chwaraeon dŵr yn teimlo'n gartrefol yma. Mannau pwrpasol ar gyfer symudiad ac anadlu, ystafell lles ar gyfer adferiad, ac wyth acer o dawelwch gwyllt i'w dal i gyd.",
        facts: ["Mannau ioga a symudiad", "Natur a chwaraeon dŵr", "Iachawd synhwyraidd yn y gwyllt"],
        cta: "Archebwch Encil",
        ctaType: "retreat",
      },
    ],
    gallery: {
      overline: "Yr Oriel",
      headingPre: "Tu mewn a thu allan,",
      headingAccent: "pob cornel wedi'i ystyried",
      note: "Ffotograffiaeth go iawn o'r plasty, yr ystafell lles a'r wyth acer",
      captions: ["Y Plasty", "Yr Ystafell Eistedd", "Y Gegin", "Y Gerddi", "Yr Ystafell Lles", "Mannau Ymgynnull", "Manylion", "Y Tir"],
    },
    location: {
      overline: "Y Lleoliad",
      headingA: "Rhwng y goedwig,",
      headingB: "y twyni a'r môr.",
      body: "Mae Bron Menai ar ymylon deheuol Ynys Môn mewn Ardal o Harddwch Naturiol Eithriadol — twyni gwellt y môr, ynysoedd llanw a mynyddoedd Eryri ar draws y culfor.",
      places: [
        { name: "Traeth Niwbwrch", time: "5 munud i ffwrdd" },
        { name: "Coedwig Niwbwrch", time: "2 funud i ffwrdd" },
        { name: "Ynys Llanddwyn", time: "10 munud i ffwrdd" },
        { name: "Eryri", time: "25 munud i ffwrdd" },
      ],
      coordsLabel: "Niwbwrch · Ynys Môn · Cymru",
    },
    footer: {
      line1: "Darganfyddwch eich gwyllt",
      line2: "yn Bron Menai",
      locationLine: "Niwbwrch · Ynys Môn · Cymru",
      copyright: "Bron Menai",
    },
    modal: {
      overline: "Holwch",
      title: "Dechreuwch eich arhosiad ym Mron Menai",
      types: { stay: "Arhosiad", wedding: "Priodas", retreat: "Encil" },
      fullName: "Enw llawn *",
      email: "E-bost *",
      phone: "Ffôn",
      date: "Dyddiad dewisol",
      partySize: "Maint y parti *",
      message: "Eich ymholiad *",
      phName: "Eich enw",
      phEmail: "chi@enghraifft.cymru",
      phPhone: "Dewisol",
      phMessage: "Dywedwch wrthym am eich cynlluniau — dyddiadau, achlysuron, unrhyw beth sy'n bwysig.",
      submit: "Anfon Ymholiad",
      sending: "Yn anfon…",
      footnote: "Yn mynd yn syth i tom@property-owl.com",
      successTitle: "Diolch.",
      successBody: "Mae eich ymholiad ar ei ffordd i dîm Bron Menai yn tom@property-owl.com. Byddwn yn cysylltu â chi yn fuan.",
      successBack: "Yn ôl i'r tŷ",
    },
    toast: {
      success: "Ymholiad wedi'i anfon — rydym wedi e-bostio tîm Bron Menai.",
      error: "Aeth rhywbeth o'i le wrth anfon eich ymholiad. E-bostiwch tom@property-owl.com yn uniongyrchol.",
    },
  },
};
